import ContactForm from "../components/ContactUs/ContactForm";
import ContactInfo from "../components/ContactUs/ContactInfo";
import HeroSection from "../components/HeroSection";
import NewsPress from "../components/News/NewsPress";
import newsData from "../NewsData/newsData";

const OurServices = () => {

    return (
        <div>

            <HeroSection
                image="https://imgix-prod.sgs.com/-/media/sgscorp/images/industries-and-environment/check-vision-concept.cdn.en.1.jpg?fit=crop&auto=format&crop=focalpoint&fp-x=0&fp-y=0&fp-z=1&w=645&h=403"
                title="Our Services"
                description={
                    <span style={{color:'white'}}>
                       Driving sustainable impact through climate innovation, digital transformation, and resilient development solutions.
                    </span>}
            />
            <div style={{display:'flex',gap:'40px',padding:'40px 80px',backgroundColor:'#f4f4f4'}}>
                <div>
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center',padding:'20px',backgroundColor:'#f4f4f4'}}>
                        <h2 style={{color:'#1a3055',fontSize:'24px',fontWeight:'bold'}}>Explore Our Services</h2>
                        <p style={{color:'#666',textAlign:'justify',maxWidth:'800px',margin:0}}>
                            At GreenWorks Consulting, we offer a comprehensive range of services designed to empower organizations in their journey towards sustainability and innovation. From climate change mitigation to digital transformation, our expert team is dedicated to delivering tailored solutions that drive positive change.
                        </p>
                    </div>
                    {/* <OurServicesSection /> */}
                </div>
                <div style={{maxWidth:'350px'}}>
                    <NewsPress data={newsData} />
                </div>
            </div>
            <div style={{padding:'40px 80px'}}>
                <div style={{display:'flex',gap:'30px',marginTop:'50px',flexWrap:'wrap'}}>
                    <ContactInfo />
                    <ContactForm />
                </div>
            </div>

        </div>
    );
}

export default OurServices;